<script setup lang="ts">
import HasPermission from "@/components/HasPermission.vue";
import RoundedBox from "@/components/RoundedBox.vue";
import StyledButton from "@/components/StyledButton.vue";
import StyledInput from "@/components/StyledInput.vue";
import useHasPermissionUser from "@/composables/useHasPermissionUser";
import useRefChangeTracker from "@/composables/useRefChangeTracker";
import EditUserPassword from "@/modules/users/components/EditUserPassword.vue";
import useUser from "@/modules/users/composables/useUser";
import type { User } from "@/modules/users/interfaces/user";
import { useQueryClient } from "@tanstack/vue-query";
import useInternalUser from "../../../composables/useInternalUser";

interface Props {
  user: User;
}

const props = defineProps<Props>();
const queryClient = useQueryClient();

const {
  value: username,
  hasChanged,
  resetInitialValue,
} = useRefChangeTracker(props.user.username ?? "");
const { updateUser, updateUserLoading } = useInternalUser({ immediate: false });

const handleSaveUsername = async () => {
  updateUser({ id: props.user.id, username: username.value });
  resetInitialValue();

  await queryClient.invalidateQueries(["user", props.user.id]);
  await queryClient.refetchQueries(["user", props.user.id]);
};
</script>

<template>
  <RoundedBox class="bg-white">
    <!--    <form @submit.prevent="handleSaveUsername" class="grid gap-[1.563rem]">-->
    <!--      <h2 class="text-xl font-medium">Ajustes generales</h2>-->

    <!--      <div class="grid gap-5 pb-2">-->
    <!--        <StyledInput-->
    <!--          v-model="username"-->
    <!--          label="Nombre de usuario"-->
    <!--          placeholder="ej. usuario123"-->
    <!--        />-->

    <!--        <HasPermission name-permission="Update users companies">-->
    <!--          <StyledButton-->
    <!--            :disabled="!hasChanged"-->
    <!--            :loading="updateUserLoading"-->
    <!--            label="Guardar"-->
    <!--            class="bg-[#253C70] text-white ml-auto"-->
    <!--            type="submit"-->
    <!--          />-->
    <!--        </HasPermission>-->
    <!--      </div>-->
    <!--    </form>-->

    <EditUserPassword
      :user-id="user.id"
      :user-email="user.email"
      :name-permission-update="'update-internal'"
      :entity-type="'App\\Models\\User'"
    />

    <!-- <EditUserEmails
      :user-id="user.id"
      :main-email="user.email"
      :emails="user.emails || []"
    /> -->
  </RoundedBox>
</template>
